import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { DashboardApi } from '@backend/api/stores/DashboardStore'
import { apiFetch, apiBase } from 'txom-frontend-libs'

type Store = ReturnType<typeof createStore>

const api = hc<DashboardApi>(apiBase + '/api/DashboardStore', { fetch: apiFetch })

type DashboardData = InferResponseType<typeof api.refresh.$get, 200>

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['DashboardStore', 'labels'],
  queryFn: async () => {
    const res = await api.refresh.$get()
    return await res.json() as DashboardData
  },
}))

// Rename dialog state
export const renamingLabelIdAtom = atom<string | null>(null)
export const renameInputAtom = atom('')

// Delete confirmation state
export const deletingLabelIdAtom = atom<string | null>(null)

// Create new label
export const createLabelAtom = atom(null, async (get) => {
  const res = await api.create.$post({ json: {} as never })
  const data = await res.json() as { id: string }
  return data.id
})

// Delete label
export const deleteLabelAtom = atom(null, async (get, set, id: string) => {
  await api.delete.$post({ json: { id } })
  set(deletingLabelIdAtom, null)
  await get(refreshAtom).refetch()
})

// Rename label
export const renameLabelAtom = atom(null, async (get, set) => {
  const id = get(renamingLabelIdAtom)
  const name = get(renameInputAtom).trim()
  if (!id || !name) return

  await api.rename.$post({ json: { id, name } })
  set(renamingLabelIdAtom, null)
  set(renameInputAtom, '')
  await get(refreshAtom).refetch()
})

export function loader(store: Store) {
  store.set(renamingLabelIdAtom, null)
  store.set(renameInputAtom, '')
  store.set(deletingLabelIdAtom, null)
  store.get(refreshAtom)
  return null
}
